import React from 'react';
import { Box, Container, Grid, Typography } from '@mui/material';

import MapOutlined from '@mui/icons-material/MapOutlined';
import SchemaOutlined from '@mui/icons-material/SchemaOutlined';
import ArchitectureOutlined from '@mui/icons-material/ArchitectureOutlined';
import CoPresentOutlined from '@mui/icons-material/CoPresentOutlined';

import { LandingCard, LandingReveal, landingCaptionSx } from './LandingMotion';

const assets = [
  {
    title: 'Context',
    mark: MapOutlined,
    body:
      'A reusable description of the organization and the decision setting, so practice stays recognizable.',
  },
  {
    title: 'Knowledge world model',
    mark: SchemaOutlined,
    body:
      'Structured, versioned, knowledge captured in world model.',
  },
  {
    title: 'Learning design',
    mark: ArchitectureOutlined,
    body:
      'A method for selecting which decisions, capabilities, and mechanisms deserve practice.',
  },
  {
    title: 'Experiential delivery',
    mark: CoPresentOutlined,
    body:
      'Decision Games today: individual, assessed, and facilitator-led.',
  },
];

const Differentiation = () => (
  <Box
    id="why-itclarifies"
    component="section"
    sx={{
      bgcolor: 'background.default',
      py: { xs: 8, md: 12 },
      borderTop: '1px solid',
      borderColor: 'divider',
      scrollMarginTop: 88,
    }}
  >
    <Container maxWidth="lg">
      <LandingReveal>
        <Typography variant="caption" sx={landingCaptionSx}>
          Differentiation
        </Typography>
        <Typography
          component="h2"
          sx={{
            mt: 1,
            mb: 1.5,
            fontWeight: 600,
            fontSize: { xs: '1.75rem', md: '2.25rem' },
            letterSpacing: '-0.02em',
            maxWidth: 560,
          }}
        >
          A better way to practice judgment
        </Typography>
        <Typography variant="body1" color="text.secondary" sx={{ mb: 5, maxWidth: 560 }}>
          Generic AI authoring and simulation assistants are widely available.
          Itclarifies connects five assets so judgment practice stays
          contextual, reusable, and human.
        </Typography>
      </LandingReveal>

      <Grid container spacing={2.5}>
        {assets.map((asset, index) => (
          <Grid item xs={12} sm={6} key={asset.title} sx={{ display: 'flex' }}>
            <LandingReveal index={index} sx={{ width: '100%', height: '100%' }}>
              <LandingCard
                kind="asset"
                mark={asset.mark}
                tone="quiet"
                title={asset.title}
                body={asset.body}
                titleComponent="h3"
              />
            </LandingReveal>
          </Grid>
        ))}
      </Grid>
    </Container>
  </Box>
);

export default Differentiation;
